module.exports = __webpack_public_path__ + "media/images/logo-92be2e840f768ce27ae4985c5069eedc.svg";